import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { AppIcon } from "../AppIcon";
import Box from "../Box";
import type { Milestone } from "./types";

type Props = {
	milestone: Milestone;
};

export const MilestoneItem = ({ milestone }: Props) => {
	const theme = useAppTheme();
	const isCompleted = milestone.status === "completed";
	const isInProgress = milestone.status === "in-progress";
	const isLocked = milestone.status === "locked";

	return (
		<Box flexDirection="row" alignItems="flex-start" gap={24}>
			<Box
				height={28}
				width={28}
				borderRadius={theme.roundness * 100}
				backgroundColor={
					isCompleted
						? theme.colors.primary
						: isInProgress
							? theme.colors.secondaryContainer
							: theme.colors.elevation.level4
				}
				alignItems="center"
				justifyContent="center"
				style={{
					borderColor: theme.colors.surface,
					borderWidth: 4,
				}}
			>
				{isCompleted ? (
					<AppIcon name="check" size={12} color={theme.colors.onPrimary} />
				) : null}
				{isInProgress ? (
					<Box
						height={10}
						width={10}
						borderRadius={theme.roundness * 100}
						backgroundColor={theme.colors.primary}
					/>
				) : null}
				{isLocked ? (
					<AppIcon
						name="lock-outline"
						size={14}
						color={theme.colors.onSurfaceVariant}
					/>
				) : null}
			</Box>
			<Box flex={1} style={{ opacity: isLocked ? 0.5 : 1 }}>
				<Text variant="bodyLarge">{milestone.title}</Text>
				<Text
					variant="bodyMedium"
					style={{
						color: isInProgress
							? theme.colors.primary
							: theme.colors.onSurfaceVariant,
					}}
				>
					{milestone.description}
				</Text>
			</Box>
		</Box>
	);
};
